import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export const getPayloadTypeList = () =>
  axiosInstance.get(API_ENDPOINTS.getPayloadTypeList);
